/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/accessible-emoji */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useEffect, useState } from 'react';
import { Badge, Button, Empty, Layout, notification, Popconfirm, Popover, theme, Tooltip } from 'antd';
import style from './LayoutPortal.module.scss';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { LogoutOutlined, DeleteOutlined } from '@ant-design/icons';
import { MainContext } from 'src/app/contexts/MainContext';
import { AuthenticationServices } from 'src/libs/services/authentication.service';
import ListCompanysTemplate from 'src/app/components/list-templates/ListTemplate';
import { SoundServices } from 'src/libs/services/sound.service';
import useSound from 'use-sound';
import { TemplateServices } from 'src/libs/services/template.service';
import { TypeItemSider } from 'src/app/components/list-templates/ItemTemplate';
import { useAtom } from 'jotai';
import { getHistoryAtom, historyAtom } from 'src/app/atoms/historyAtom';
import { favoritesTemplateAtom, getFavoritesTemplateAtom } from 'src/app/atoms/favoritesTemplateAtom ';
// import { useMsal } from '@azure/msal-react';
import { getParamsConfigGlobalAtom, OpenModalConfig } from 'src/app/atoms/paramsConfigAtom';
import { openListFileUploadedAtom } from 'src/app/atoms/getListFileUploadAtom';
import { useTranslation } from 'react-i18next';
import LanguageHeader from 'src/app/components/language-header/LanguageHeader';
import ModalConfig from 'src/app/components/modal-config/ModalConfig';
import configImg from '../../../assets/images/icons/settings.png';
import { ColapseIcon } from 'src/app/components/icon-custom/IconCustom';
import userLoginImg from '../../../assets/images/icons/user-login.png';
import NotiImg from '../../../assets/images/icons/BellRinging.png';
import useNoti from 'src/app/hooks/useNoti';
import { Noti } from 'src/app/atoms/NotiAtom';
import LogoAssistant from '../../../assets/images/logo-assistant.png';
import IconCreateNew from '../../../assets/images/icons/ChatCircle.png';
import useWindowSize from 'src/libs/hooks/useWindowSize';
import IconChatMenu from '../../../assets/images/icons/message-text-circle.png';
import IconLibraryMenu from '../../../assets/images/icons/book-open.png';
const { Header, Content, Sider } = Layout;

export type LayoutPortalType = {
  children?: any;
};

const LayoutPortal = (props: LayoutPortalType) => {
  const [play] = useSound(SoundServices.srcTurnOn);
  const mainContext = useContext(MainContext);
  const [collapsed, setCollapsed] = useState(false);
  const [isSound, setIsSound] = useState<boolean>(false);
  const [templates, setTemplates] = useState([]);
  const [history, setHistory] = useAtom(historyAtom);
  const [, getDataHistory] = useAtom(getHistoryAtom);
  const [favoritesTemplate, setFavoritesTemplate] = useAtom(favoritesTemplateAtom);
  const [, getFavoritesTemplate] = useAtom(getFavoritesTemplateAtom);
  const [, getParamsConfigGlobal] = useAtom(getParamsConfigGlobalAtom);
  const [openListFiles, setOpenListFile] = useAtom(openListFileUploadedAtom);
  const { t } = useTranslation();
  const [openConfig, setOpenConfig] = useAtom(OpenModalConfig);
  const authenticated = JSON.parse(`${localStorage.getItem('user_login')}`);
  const [dataLogin, setDataLogin] = useState<any>({});
  const { width } = useWindowSize();

  const { notiData, readAll, removeNoti, countUnreadNoti } = useNoti();
  const content = (
    <ul className={style.wrapperNotiList}>
      {notiData.map((noti: Noti) => (
        <li className={style.notiItem} key={noti.id}>
          <p className={`${style.notiMessage} ${noti.isReaded ? null : style.notRed}`}>
            {t(noti.message, { fileName: decodeURIComponent(noti?.fileName) })}
          </p>
          <p style={{ fontSize: '0.8em', color: 'gray' }}>
            {noti.createdAt}
          </p>
          <Button
            className={style.btnRemoveNoti}
            type="link"
            danger
            size='small'
            onClick={()=>{removeNoti(Number(noti.id))}}
            icon={<DeleteOutlined />}
          > </Button>
        </li>
      ))}
    </ul>
  );
  

  const navigation = useNavigate();

  // const { instance } = useMsal(); // in hooks have: instance, accounts, inProgress

  const logout = () => {
    AuthenticationServices.logout();
    window.location.replace('/');
    // try {
    //   instance.logoutRedirect({
    //     postLogoutRedirectUri: "/",
    //   });
    //   // if (!instance.getActiveAccount()) {
    //   //   console.warn("No active account to log out.", instance.getActiveAccount());
    //   // } else {
    //   //   instance.logoutRedirect({
    //   //     postLogoutRedirectUri: "/",
    //   //   });
       
    //   // }
    //   // instance.logout().then(
    //     //   (res) => {
    //     //     console.log(res);
    //     //     navigation('/login');
    //     //   },
    //     //   (err) => {
    //     //     console.log(err)
    //     //   }
  
    //     // )
    // } catch (error) {
    //   console.log(error)
    // }

    // navigation('/login');
  };

  const onClickLogo = () => {
    navigation('/');
  }

  const getTemplates = () => {
    TemplateServices.getTemplates().then(
      (res) => {
        setTemplates(res.data);
      },
      (err) => { }
    );
  }

  const toggleConfigure = () => {
    setOpenConfig(!openConfig);
    getParamsConfigGlobal();
    // Disable configuration panel
    // mainContext?.setOpenConfigure(!mainContext?.openConfigure);
    // if (!mainContext?.openConfigure) {
    //   getParamsConfigGlobal();
    // }
  }

  const onSound = () => {
    if (SoundServices.isTurnOn()) {
      SoundServices.turnOffSound();
      setIsSound(false);
    } else {
      SoundServices.turnOnSound();
      setIsSound(true);
      play();
    }
  }

  const sortFavoriteTemplates= (records: any[]) => {
    return records.sort((a, b) => {
      return b?.isFavorite === true ? 1 : -1;
    })
  }

  const createNewChat = () => {
    navigation('/');
  }

  const OpenDocumentsList = () => {
    setOpenListFile(true);
  }

  useEffect(() => {
    getTemplates();
    getDataHistory();
    getFavoritesTemplate();
    getParamsConfigGlobal();
    setDataLogin(authenticated);
    if (SoundServices.isTurnOn()) {
      setIsSound(true);
    } else {
      setIsSound(false);
    }
  }, []);

  return (
    <Layout className={style.mainLayout}>

      <Layout className={style.LayoutMain}>
        <Header className={style.Header}>
          <div className={style.HeaderWrapper}>
            <div onClick={onClickLogo}
              className={`${style.Logo} ${collapsed ? style.collapsed: ''}`}
            >
              {/* <span>QaiDora</span> Assistant */}
              {/* <Button type="text" onClick={() => setCollapsed(!collapsed)} icon={<ColapseIcon />}></Button>
              <Button type="text" onClick={createNewChat}
                icon={<img className={style.createNewChatIcon} alt='Create new chat' src={IconCreateNew} width={25} />}>  
              </Button> */}
              {/* <img alt='logo' className={style.logoIconMobile} src={LogoAssistant} width={155}/> */}
            </div>
            <div className={style.icons}>
              {/* <span role="img">📋</span> */}
              {/* <Link to={{ pathname: '/files' }}>Documents</Link> */}
              {/* <Button className={style.btnCreateNew} size='small' onClick={OpenDocumentsList}>
                {t('Your files')}
              </Button> */}
              {/* <span> | </span> */}
              
              {/* <span title="Configure" role="img" onClick={toggleConfigure}>
                <img alt='' src={configImg} width={24}/>
              </span> */}
              {/* <LanguageHeader hideArrow />
              <Popover
                overlayInnerStyle={{
                  backdropFilter: 'blur(40px)', 
                  backgroundColor: 'rgba(0, 0, 200, 0.1)',
                  border: '1px solid #ffffff1c',
                }}
                onOpenChange={(visible: boolean) => {
                  console.log('onOpenChange', visible);
                  if (!visible) {
                    readAll();
                  }
                }}
                content={notiData.length > 0
                  ? content
                  : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} imageStyle={{ width: '80px', margin: ' 0 auto' }} description={false} />
                }
                title={(<h2 className={style.titlePopupNoti}>
                  {t("Notifications")}
                </h2>)}
                trigger={["click"]}>
                <Badge dot count={countUnreadNoti() || 0} size='small'>
                  <span className={style.NotiIcon} title="Noti" role="img">
                    <img alt='' src={NotiImg} width={24} />
                  </span>
                </Badge>
              </Popover>
              <ModalConfig /> */}
              {/* <span role="img" className={`${!isSound ? style.soundOff : ''}`} onClick={onSound}>🔊</span> */}
             
              {/* <Popconfirm
                title={t("Are you sure you want to logout?")}
                onConfirm={logout}
                okText={t("OK")}
                cancelText={t("Cancel")}
              >
              <Button style={{ marginLeft: "5px" }} size="small" shape="circle" type="primary" danger title='Logout'>
                <LogoutOutlined />
              </Button>
              </Popconfirm> */}
              <div className={style.userLogin}>
                <img alt='' src={userLoginImg} width={24} />
                <Tooltip title={dataLogin?.email}>
                  <p>{dataLogin?.email}</p>
                </Tooltip>
              </div>
            </div>
          </div>
        </Header>
        <Content>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};
export default LayoutPortal;
